export const isMemberType = (memberType: 'CLIENT' | 'AGENT', isTrue: any, isFalse?: any) => (props: any) => {
	const currentMemberType = props.theme.memberType;
	return memberType === currentMemberType ? isTrue : isFalse;
};
